"use client";
import { useEffect, useState } from "react";
import RaidoField from "../../../components/common/RaidoField";
import SelectInput from "../../../components/Select";
import TextareaField from "../../../components/common/TextareaField";
import { PickupRequestFormData } from "../../../types/types";
import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import { useFetchPickupLocationData, useFetchOutletWarehouses } from "../../../apis/pickupApis";
import Input from "../../../components/Input";

const logisticVehicleTypes = [
  { id: 1, value: "car", text: "Car" },
  { id: 2, value: "van", text: "Van" },
  { id: 3, value: "dokker", text: "Dokker" },
];

interface CreatePickupRequestProps {
  register: UseFormRegister<PickupRequestFormData>;
  setValue: UseFormSetValue<PickupRequestFormData>;
  watch: UseFormWatch<PickupRequestFormData>;
  errors: FieldErrors<PickupRequestFormData>;
  clearErrors: UseFormClearErrors<PickupRequestFormData>;
  control: Control<PickupRequestFormData>;
  reset?: any;
}

const GeneratePickupRequest: React.FC<CreatePickupRequestProps> = ({
  register,
  errors,
  setValue,
  watch,
  control,
  clearErrors,

  reset,
}) => {
  const [mode, setMode] = useState("pickupRequest");
  const { data: allPickupLocationData } = useFetchPickupLocationData();
  console.log(allPickupLocationData, "allPickupLocationData");

  const { data: outletWarehouses } = useFetchOutletWarehouses();


  const location = Array.isArray(allPickupLocationData)
    ? allPickupLocationData[0]
    : allPickupLocationData?.data
      ? (Array.isArray(allPickupLocationData.data) ? allPickupLocationData.data[0] : allPickupLocationData.data)
      : allPickupLocationData;

  useEffect(() => {
    if (location?.id) {
      setValue("locationId", location.id);
    }
  }, [location, setValue]);

  useEffect(() => {
    setValue("requestType", mode === "pickupRequest" ? "PICKUP" : "DROPOFF");
  }, [mode, setValue]);
  return (
    <div className="p-4">
      <div className="grid grid-cols-6 gap-4">
        <div className="col-span-6">
          <RaidoField
            label=""
            value={mode}
            onClick={(val) => {
              if (typeof val === "string") {
                setMode(val);
              }
            }}
            valuesArr={[
              { value: "pickupRequest", text: "Pickup Request" },
              { value: "dropRequest", text: "Drop off Request" },
            ]}
          />
        </div>
        {mode === "pickupRequest" && (
          <>
            <SelectInput
              className="col-span-3"
              label="Select Vehicle Type"
              selectOptions={logisticVehicleTypes}
              name="vehicleType"
              placeholder="Select Vehicle Type"
              register={register}
              clearErrors={clearErrors}
              validation={{ required: "Vehicle Type is required" }}
              error={errors.vehicleType}
              disabled={!logisticVehicleTypes.length}
              value={watch("vehicleType")}
              setValue={(value: any) => {
                setValue("vehicleType", value);
              }}
            />
            {/* <SelectInput
              className="col-span-3"
              label="Select Location"
              selectOptions={
                location
                  ? [
                      {
                        id: location.id,
                        value: location.id,
                        text: location.fullAddress,
                      },
                    ]
                  : []
              }
              name="locationId"
              placeholder="Select Location"
              register={register}
              clearErrors={clearErrors}
              validation={{ required: "Location is required" }}
              error={errors.locationId}
              disabled={!location}
              value={watch("locationId")}
              setValue={(value: any) => {
                setValue("locationId", value);
              }}
            /> */}
            {location && (
              <div className="col-span-3">
                <Input
                  name=""
                  title="Pickup Location"
                  value={location.fullAddress}
                  disabled
                />
              </div>
            )}
            <SelectInput
              className="col-span-3"
              label="Select Warehouse"
              selectOptions={
                outletWarehouses?.map((item: any) => ({
                  id: item.id,
                  value: item.id,
                  text: item.name || item.warehouseName,
                })) || []
              }
              name="warehouseId"
              placeholder="Select Warehouse"
              register={register}
              clearErrors={clearErrors}
              validation={{ required: "Warehouse is required" }}
              error={errors.warehouseId}
              disabled={!outletWarehouses?.length}
              value={watch("warehouseId")}
              setValue={(value: any) => {
                setValue("warehouseId", value);
              }}
            />

            {/* Hidden field for locationId */}
            <input
              type="hidden"
              {...register("locationId", { required: true })}
              value={location?.id || ""}
            />

            <Input
              className="col-span-3"
              type="date"
              name="pickupDate"
              title="Preferred Pickup Date"
              placeholder="Select Date"
              register={register}
              error={errors.pickupDate}
              min={new Date().toLocaleDateString("en-CA")}
              validation={{
                required: "Pickup Date is required",
                validate: (value: string) => {
                  const selectedDate = new Date(value);
                  selectedDate.setHours(0, 0, 0, 0);
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  return selectedDate >= today || "Date cannot be in the past";
                },
              }}
            />
            <Input
              className="col-span-3"
              title="Preferred Time Slot"
              type="time"
              name="timeSlot"
              placeholder="Select Time Slot"
              register={register}
              error={errors.timeSlot}
              validation={{
                required: "Time Slot is required",
                validate: (value: string) => {
                  const selectedDate = watch("pickupDate");
                  if (!selectedDate) return true;

                  const today = new Date();
                  const dateOnly = today.toLocaleDateString("en-CA");

                  if (selectedDate === dateOnly) {
                    const currentTime = today.getHours() * 60 + today.getMinutes();
                    const [hours, minutes] = value.split(":").map(Number);
                    const selectedTime = hours * 60 + minutes;
                    return selectedTime > currentTime || "Time cannot be in the past";
                  }
                  return true;
                },
              }}
            />

            <TextareaField
              className="col-span-6"
              label={"Special Instructions"}
              placeholder={"Write here..."}
              name="specialInstructions"
              register={register}
              error={errors.specialInstructions}
              validation={{ required: "Special Instructions is required" }}
            />
          </>
        )}
        {mode === "dropRequest" && (
          <>
            <Input
              className="col-span-3"
              type="date"
              name="pickupDate"
              title="Preferred Pickup Date"
              placeholder="Select Date"
              register={register}
              error={errors.pickupDate}
              min={new Date().toLocaleDateString("en-CA")}
              validation={{
                required: "Pickup Date is required",
                validate: (value: string) => {
                  const selectedDate = new Date(value);
                  selectedDate.setHours(0, 0, 0, 0);
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  return selectedDate >= today || "Date cannot be in the past";
                },
              }}
            />
            <Input
              className="col-span-3"
              title="Preferred Time Slot"
              type="time"
              name="timeSlot"
              placeholder="Select Time Slot"
              register={register}
              error={errors.timeSlot}
              validation={{
                required: "Time Slot is required",
                validate: (value: string) => {
                  const selectedDate = watch("pickupDate");
                  if (!selectedDate) return true;

                  const today = new Date();
                  const dateOnly = today.toLocaleDateString("en-CA");

                  if (selectedDate === dateOnly) {
                    const currentTime = today.getHours() * 60 + today.getMinutes();
                    const [hours, minutes] = value.split(":").map(Number);
                    const selectedTime = hours * 60 + minutes;
                    return selectedTime > currentTime || "Time cannot be in the past";
                  }
                  return true;
                },
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default GeneratePickupRequest;
